import { getAuthToken } from '@/utils/local-storage'
import HttpRequest from './http_request'

export default class OrderProvider extends HttpRequest {
  getBills (page, perPage, search, warehouse, sortBy, sortOrder) {
    this.setHeader(getAuthToken())
    return this.get(`/bills?page=${page}&perPage=${perPage}&search=${search}&warehouse=${warehouse}&sortBy=${sortBy}&sortOrder=${sortOrder}`)
  }

  createOrder (payload) {
    this.setHeader(getAuthToken())
    return this.post('/bills', payload)
  }

  updateOrder (id, payload) {
    this.setHeader(getAuthToken())
    return this.put(`/bills?billId=${id}`, payload)
  }

  getBillById (billId) {
    this.setHeader(getAuthToken())
    return this.get(`/bills/${billId}`)
  }

  removeBill (billId) {
    this.setHeader(getAuthToken())
    return this.remove(`/bills?id=${billId}`)
  }
}
